import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NamesSteps } from '@/helpers/auth';
import { ScFormTextHeader } from './styled';

interface IFormTextHeaderProps {
  size?: 'large' | 'small';
  currentStep?: NamesSteps;
  personalDataTitle?: string;
  addressInfoTitle?: string;
}

export const FormTextHeader = ({
  size,
  currentStep,
  personalDataTitle,
  addressInfoTitle,
}: IFormTextHeaderProps) => {
  const { t } = useTranslation('common');

  const isSmallSize = size === 'small';

  const isPersonalDataStep = currentStep === NamesSteps.PERSONAL_INFORMATION;
  const isAddressInfoStep = currentStep === NamesSteps.ADDRESS_INFORMATION;

  const headerText = useMemo(() => {
    if (isPersonalDataStep && personalDataTitle) {
      return <h2>{t(personalDataTitle)}</h2>;
    }

    if (isAddressInfoStep && addressInfoTitle) {
      return <h2>{t(addressInfoTitle)}</h2>;
    }

    return <h2>{t('auth.registration.title')}</h2>;
  }, [
    isPersonalDataStep,
    personalDataTitle,
    addressInfoTitle,
    t,
    isAddressInfoStep,
  ]);

  return (
    <ScFormTextHeader $isSmallSize={isSmallSize}>{headerText}</ScFormTextHeader>
  );
};
